var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 64,
    viewBox: "0 0 60 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5779 43.0801C21.5226 43.4699 21.4939 43.8682 21.4939 44.2731C21.4939 48.9425 25.3022 52.7277 30 52.7277C34.6978 52.7277 38.5061 48.9425 38.5061 44.2731C38.5061 43.8682 38.4775 43.4699 38.4221 43.0801H59.0625V61.8868C59.0625 63.0541 58.1104 64.0004 56.936 64.0004H3.06402C1.88958 64.0004 0.9375 63.0541 0.9375 61.8868V43.0801H21.5779Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2149 42.8643C39.2149 47.9228 35.0893 52.0234 30 52.0234C24.9107 52.0234 20.7851 47.9228 20.7851 42.8643C20.7851 42.7005 20.7894 42.5376 20.7979 42.3758H0.9375L7.71434 22.4599C8.00649 21.6013 8.81688 21.0234 9.72877 21.0234H50.2712C51.1831 21.0234 51.9935 21.6013 52.2857 22.4599L59.0625 42.3758H39.2021C39.2106 42.5376 39.2149 42.7005 39.2149 42.8643Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8618 43.5358C37.8618 47.4446 34.3399 51.3178 29.9954 51.3178C25.6509 51.3178 22.129 47.4446 22.129 43.5358C22.129 43.4092 22.1327 42.5788 22.14 42.4538H7.3125L13.0976 28.4733C13.347 27.8098 14.0388 27.3633 14.8172 27.3633H45.1736C45.9521 27.3633 46.6439 27.8098 46.8933 28.4733L52.6784 42.4538H37.8508C37.8581 42.5788 37.8618 43.4092 37.8618 43.5358Z",
    fill: "#F0FBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.82031 42.5209V61.1827C1.82031 61.8637 2.37569 62.4157 3.06079 62.4157H56.9328C57.6178 62.4157 58.1732 61.8637 58.1732 61.1827V42.5209L51.4431 22.7422C51.2727 22.2414 50.8 21.9043 50.268 21.9043H9.72553C9.19359 21.9043 8.72087 22.2414 8.55045 22.7422L1.82031 42.5209Z",
    stroke: "#00A4BF",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8578 42.1582C13.6482 42.1582 16.6596 42.1582 19.8919 42.1582C21.2219 42.1582 21.2219 43.0872 21.2219 43.5673C21.2219 48.2366 25.1178 52.0218 29.9237 52.0218C34.7296 52.0218 38.6255 48.2366 38.6255 43.5673C38.6255 43.0872 38.6255 42.1582 39.9555 42.1582H57.6413M5.59375 42.1582H7.31359H5.59375Z",
    stroke: "#00A4BF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7897 5.03147L39.9219 13.8053M29.3599 2V13.8053V2ZM10.8594 5.03147L18.7272 13.8053L10.8594 5.03147Z",
    stroke: "#00BADB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBox);
export default __webpack_public_path__ + "static/media/message-box.0281488a3f3d1ebbf693433b0b3f6cb6.svg";
export { ForwardRef as ReactComponent };